import { LoadBankParameters } from './LoadBankParameters';

export class LoadBankGenerator {
    quantityBuilder: number = 0;
    prefixBuilder: string = '';
    numberBuilder: string = '';
    suffixBuilder: string = '';
    loadNumbers: string[] = [];
    description: string = '';
    commodityCode: string = '';
    customerId: number = 0;
    customerCode: string = '';
    customerName: string = '';
    customerContract: string = '';
    locationId: number = 0;
    locationName: string = '';
    locationCity: string = '';
    contractId: number = 0;
    contractNumber: string = '';
    shipFrom: string = '';
    shipTo: string = '';
    locationSearchAll: string = '';
    userName: string = '';

    loadBankParameters: LoadBankParameters = new LoadBankParameters();
}